import { Helmet } from 'react-helmet-async';

function Thanks() {
    return (
        <>
            <Helmet>
                <title>アンケートへのご協力ありがとうございました。</title>
                <meta name="description" content="アンケートへのご協力ありがとうございました。" />
            </Helmet>
            <div className="thanks-container">
                <div className="thanks-window">
                    <div className="thanks-window__message">
                        <p>アンケートへのご協力ありがとうございました。<br />下記URLより謝礼応募のご案内にお進みください。</p>
                        <a href="https://id.sankei.jp/s/14059" target="_blank" rel="noreferrer">https://id.sankei.jp/s/14059</a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Thanks;
